// removed by extract-text-webpack-plugin
module.exports = {"popUpContainer":"styles__popUpContainer__2IGEw","popUp":"styles__popUp__1IhP1","buttonsContainer":"styles__buttonsContainer__2FFHK","button":"styles__button__22UFc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PopUp/styles.less
// module id = 374
// module chunks = 0